import { withPrefix } from "gatsby";
import { retrieveOneTrust } from "./onetrust";
const DEV_PATH_PREFIX = process.env.PATH_PREFIX ?? "";

const bazaarVoiceGroups = ["C0003"];
const siteLocale = DEV_PATH_PREFIX || withPrefix("/");

export const BAZAAR_VOICE_SCRIPT_ID = "bazaar-voice-loader";

function createScript() {
  const script = document.createElement("script");
  script.id = "bazaar-voice-loader";
  script.setAttribute(
    "src",
    `https://apps.bazaarvoice.com/deployments/haier-europe/main_site/production${siteLocale}bv.js`
  );
  script.setAttribute("async", "");
  document.head.appendChild(script);
}

function areEnabledBazaarVoiceCookies() {
  return (
    window.OnetrustActiveGroups &&
    bazaarVoiceGroups.some((item) => window.OnetrustActiveGroups.includes(item))
  );
}

export async function insertBazaarVoiceScript() {
  if (document.getElementById(BAZAAR_VOICE_SCRIPT_ID)) {
    return;
  }
  if (process.env.NODE_ENV === "development") {
    createScript();
    return;
  }

  const oneTrust = await retrieveOneTrust();
  if (!oneTrust) {
    return;
  }
  oneTrust.OnConsentChanged((e) => {
    if (areEnabledBazaarVoiceCookies()) {
      createScript();
    }
  });
  if (oneTrust.IsAlertBoxClosed() && areEnabledBazaarVoiceCookies()) {
    createScript();
  }
}
